import React, { useEffect, useState } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { API_BASE_URL } from "../../../config";
import { Link } from "react-router-dom";

const PermissionReport = () => {

 const [filters, setFilters] = useState({
  start_date: new Date(),
  end_date: new Date(),
  dept_id: "0"
});

  const [departments, setDepartments] = useState([]);
  const [data, setData] = useState([]);
  const [totalHours, setTotalHours] = useState(0);

  // ✅ Load departments
  useEffect(() => {

    const token = localStorage.getItem("authToken");

    if (!token) {
      window.location.href = "/login";
      return;
    }

    axios.get(`${API_BASE_URL}/permission_report`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    .then(res => {
      console.log("Departments API:", res.data);
      setDepartments(res.data?.data?.departments || []);
    })
    .catch(err => {
      console.error(err);
      if (err.response?.status === 401) {
        localStorage.removeItem("authToken");
        window.location.href = "/login";
      }
      setDepartments([]);
    });

  }, []);

  // 🔹 Handle change
  const handleChange = (e) => {
    setFilters({
      ...filters,
      [e.target.name]: e.target.value
    });
  };

  // 🔹 Fetch report
  const fetchReport = () => {

    if (!filters.start_date || !filters.end_date) {
      alert("Please select date range");
      return;
    }

    const payload = {
      dept_id: filters.dept_id,
      start_date: filters.start_date.toISOString().split("T")[0],
      end_date: filters.end_date.toISOString().split("T")[0],
    };

    console.log("Payload:", payload);

    axios.get(`${API_BASE_URL}/permission_report_list`, {
      params: payload,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`
      }
    })
    .then(res => {
      console.log("Report Data:", res.data);
      const tableData = res.data?.data || [];
      setData(tableData);

      const total = tableData.reduce((sum, item) => {
        return sum + parseFloat(item.hours || 0);
      }, 0);

      setTotalHours(total);
    })
    .catch(err => {
      console.error("Report API Error:", err);
    });
  };

  const columns = [
    { name: "Employee ID", selector: row => row.employee_id, sortable: true },
    { name: "Employee Name", selector: row => row.employee_name, sortable: true },
    { name: "Department", selector: row => row.department, sortable: true },
    { name: "Hours", selector: row => row.hours, sortable: true },
    { name: "Date", selector: row => row.date, sortable: true },
    { name: "Reason", selector: row => row.reason, wrap: true },
    { name: "Type", selector: row => row.type, sortable: true }
  ];



  const downloadCSV = () => {
  if (!data.length) {
    alert("No data to download");
    return;
  }

  const headers = [
    "Employee ID",
    "Employee Name",
    "Department",
    "Hours",
    "Date",
    "Reason",
    "Type"
  ];

  const rows = data.map(row => [
    row.employee_id,
    row.employee_name,
    row.department,
    row.hours,
    row.date,
    row.reason,
    row.type
  ]);

  let csvContent =
    "data:text/csv;charset=utf-8," +
    [headers, ...rows]
      .map(e => e.map(v => `"${v ?? ""}"`).join(","))
      .join("\n");

  const encodedUri = encodeURI(csvContent);
  const link = document.createElement("a");

  link.setAttribute("href", encodedUri);
  link.setAttribute("download", "permission_report.csv");
  document.body.appendChild(link);

  link.click();
  document.body.removeChild(link);
};
  return (
    <div className="container">

      {/* Navigation */}
      <div className="mb-3 d-flex gap-2">
        <Link to="/permission" className="btn btn-outline-secondary btn-sm">
          Permission
        </Link>
        <Link to="/permission-report" className="btn btn-info btn-sm">
          Permission Report
        </Link>
      </div>

      <h3>Permission Report</h3>

      {/* ✅ All filters in one perfectly aligned row */}
      <div className="row g-3 mb-3" style={{ alignItems: "flex-end" }}>

        <div className="col-md-3 d-flex flex-column">
          <label className="form-label mb-1" style={{ height: "24px" }}>From Date</label>
          <DatePicker
            selected={filters.start_date}
            onChange={(date) => setFilters({ ...filters, start_date: date })}
            className="form-control"
            dateFormat="yyyy-MM-dd"
            placeholderText="Select start date"
            wrapperClassName="w-100"
          />
        </div>

        <div className="col-md-3 d-flex flex-column">
          <label className="form-label mb-1" style={{ height: "24px" }}>To Date</label>
          <DatePicker
            selected={filters.end_date}
            onChange={(date) => setFilters({ ...filters, end_date: date })}
            className="form-control"
            dateFormat="yyyy-MM-dd"
            placeholderText="Select end date"
            wrapperClassName="w-100"
          />
        </div>

        <div className="col-md-3 d-flex flex-column">
          <label className="form-label mb-1" style={{ height: "24px" }}>Department</label>
          <select
            name="dept_id"
            onChange={handleChange}
            className="form-control"
            value={filters.dept_id}
            style={{ height: "38px" }}
          >
            <option value="0">All</option>
            {departments.length > 0 ? (
              departments.map(d => (
                <option key={d.department_id} value={d.department_id}>
                  {d.department_name}
                </option>
              ))
            ) : (
              <option disabled>No departments found</option>
            )}
          </select>
        </div>

        <div className="col-md-2 d-flex flex-column">
  <label style={{ height: "15px" }}>&nbsp;</label>
  <button
    type="submit"
    className="btn btn-danger mt-4"
    onClick={fetchReport}
    style={{ height: "38px" }}
  >
    Get
  </button>


  
</div>

      </div>
<div className="col-md-2 d-flex flex-column">
  <label style={{ height: "15px" }}>&nbsp;</label>
  <button
    className="btn btn-success mt-4"
    onClick={downloadCSV}
    style={{ height: "38px" }}
  >
     CSV
  </button>
</div>
      <h5 className="mt-2">
        Total Permission Hours = {totalHours}
      </h5>

      <DataTable
        columns={columns}
        data={data}
        pagination
        striped
        highlightOnHover
      />

    </div>
  );
};

export default PermissionReport;